
export class InvoiceQueryParams {
    id?: string;
    projection: string;
}
